import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';

export const useReCaptcha = () => {
    const {executeRecaptcha} = useGoogleReCaptcha();

    const retrieveCaptchaToken = async (action: string, onError: (error: string) => void) => {
        if (executeRecaptcha === undefined) {
            onError && onError('Recaptcha not initialized.');
        }
        return (executeRecaptcha && (await executeRecaptcha(action))) || '';
    };

    return {
        retrieveCaptchaToken,
    };
};
